import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";
import BrandMark from "@/components/BrandMark";

const GESTION_URL = "https://pcvigogestion.com/";

export default function GestionPage() {
  // Nota: cuando el proyecto de pcvigogestion.com implemente /sso, se podrá cargar
  // la URL con token (GET /api/auth/sso-link) para entrar ya con la sesión iniciada.
  const [src] = useState(GESTION_URL);

  return (
    <div data-testid="gestion-page" className="h-screen flex flex-col bg-[#fffbf2] text-[#0f2027]">
      <header className="bg-[#e65100] text-white px-6 py-3 shrink-0">
        <div className="max-w-full mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <BrandMark className="w-8 h-8" />
            <div className="leading-none">
              <span className="block font-display text-sm tracking-wider uppercase">GESTIÓN PCVIGO</span>
              <span className="block text-[10px] tracking-widest text-white/80 font-mono-tactical uppercase">
                Protección Civil Concello de Vigo
              </span>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <Link
              to="/campus"
              data-testid="gestion-back-link"
              className="flex items-center gap-2 text-xs font-mono-tactical uppercase tracking-wider hover:underline"
            >
              <ArrowLeft className="w-3.5 h-3.5" aria-hidden="true" />
              Volver al campus
            </Link>
            <a
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="gestion-open-external"
              className="flex items-center gap-2 border border-white/40 px-3 py-1.5 text-xs font-mono-tactical uppercase tracking-wider rounded hover:bg-white/10 transition-colors"
            >
              <ExternalLink className="w-3.5 h-3.5" aria-hidden="true" />
              Abrir aparte
            </a>
          </div>
        </div>
      </header>
      <iframe
        src={src}
        title="Plataforma de gestión PCVigo"
        data-testid="gestion-iframe"
        className="flex-1 w-full border-0"
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
}
